export const tpSplitOptions = [
  { label: 'Overall TP Ratio', value: 'all' },
  { label: 'Advance TP Ratio', value: 'split' },
]
